export default {
  "meta.title": "Przewodnik USFans Spreadsheet: znajdź produkty i kupuj mądrzej",
  "meta.description":
    "Dowiedz się, jak korzystać z USFans Spreadsheet: przeglądaj produkty według kategorii, porównuj, poznaj QC, wysyłkę i wskazówki zakupowe, i kupuj z pewnością.",

  "breadcrumb.home": "Strona główna",
  "breadcrumb.current": "Przewodnik po Spreadsheet",

  "title": "Przewodnik USFans Spreadsheet: znajdź produkty, porównuj i kupuj mądrzej",
  "lead":
    "USFans Spreadsheet to jeden z najbardziej przydatnych sposobów odkrywania i porównywania produktów w wielu kategoriach. Ten oryginalny przewodnik wyjaśnia, jak działa, jak poruszać się po kategoriach i co sprawdzić przed zakupem — aby podejmować lepsze decyzje.",

  "toc.title": "Spis treści",

  "s1.title": "Czym jest USFans Spreadsheet?",
  "s1.p1":
    "USFans Spreadsheet to wspólny, uporządkowany katalog produktów. Zamiast strony z przypadkowymi linkami, grupuje przedmioty w jasne kategorie, takie jak Buty, Bluzy, T-shirty, Kurtki, Spodnie, Nakrycia głowy, Torby i Akcesoria. Ta struktura znacznie ułatwia znalezienie konkretnego typu produktu i porównanie tego, co jest dostępne.",
  "s1.p2":
    "Wiele osób używa spreadsheetu jako punktu wyjścia do researchu produktów. Pozwala zobaczyć na pierwszy rzut oka, jakie kategorie istnieją, jakie produkty są wymienione i gdzie dalej szukać informacji.",

  "s2.title": "Jak korzystać ze Spreadsheetu krok po kroku",
  "s2.p1":
    "Korzystanie ze spreadsheetu jest proste, nawet dla początkujących. Wykonaj te kroki, aby w pełni z niego skorzystać.",
  "s2.li1": "Wybierz kategorię, która Cię interesuje, np. Buty lub Torby.",
  "s2.li2": "Przejrzyj produkty wymienione w tej kategorii.",
  "s2.li3": "Porównaj dostępne informacje, w tym zdjęcia i opisy.",
  "s2.li4": "Sprawdź uwagi QC i szczegóły wysyłki przed podjęciem decyzji.",
  "s2.li5": "Podążaj za linkiem do głównej strony, aby zobaczyć szczegóły i zamówić.",
  "s2.p2":
    "Dzięki organizacji według kategorii oszczędzasz czas w porównaniu z nieuporządkowaną listą. Możesz od razu przejść do sekcji, która Cię interesuje.",

  "s3.title": "Przeglądaj główne kategorie produktów",
  "s3.p1":
    "Spreadsheet obejmuje szeroką gamę typów produktów. Poniżej znajdziesz główne kategorie z krótką notatką o każdej z nich.",
  "s3.shoes": "Buty — sneakersy, obuwie casual i sportowe.",
  "s3.hoodies": "Bluzy/Swetry — bluzy i z zamkiem.",
  "s3.tshirts": "T-shirty — koszulki z krótkim i długim rękawem.",
  "s3.jackets": "Kurtki — odzież wierzchnia na różne pory roku.",
  "s3.pants": "Spodnie/Szorty — jeansy, chinosy i szorty.",
  "s3.headwear": "Nakrycia głowy — czapki, kapelusze i beanie.",
  "s3.sets": "Zestawy — dopasowane, skoordynowane stroje.",
  "s3.underwear": "Bielizna/Majtki — bielizna i bokserki.",
  "s3.jersey": "Koszulki sportowe — sportowe i drużynowe.",
  "s3.accessories": "Akcesoria — drobne dodatki i dodatki.",
  "s3.bags": "Torby — plecaki, torebki i torby.",
  "s3.belts": "Paski — skórzane i casualowe.",
  "s3.perfumes": "Perfumy — zapachy dla kobiet i mężczyzn.",
  "s3.other": "Inne rzeczy — różne i nowości.",
  "s3.p2":
    "Każdą kategorię możesz przeglądać ze strony głównej za pomocą rozwijanego menu lub kart kategorii. Każda otwiera odpowiadającą sekcję na głównej stronie.",

  "s4.title": "Co sprawdzić przed zakupem",
  "s4.p1":
    "Dobra decyzja zakupowa zaczyna się od szybkiego sprawdzenia informacji o produkcie. Oto kluczowe rzeczy do weryfikacji przy każdej ofercie.",
  "s4.li1": "Zdjęcia produktu — upewnij się, że wyraźnie pokazują przedmiot.",
  "s4.li2": "Opis — przeczytaj szczegóły dotyczące materiału, rozmiaru i koloru.",
  "s4.li3": "Informacje QC — szukaj zdjęć kontroli jakości, jeśli są dostępne.",
  "s4.li4": "Warunki wysyłki — poznaj koszt i szacowany czas.",
  "s4.li5": "Metody płatności — potwierdź dostępne opcje.",
  "s4.p2":
    "Poświęcenie kilku sekund na sprawdzenie tych szczegółów pomaga uniknąć niespodzianek i wybrać produkty zgodne z oczekiwaniami.",

  "s5.title": "Uwagi dotyczące wysyłki i dostawy",
  "s5.p1":
    "Koszty i czasy wysyłki mogą się różnić w zależności od lokalizacji i produktu. Ogólnie cięższe lub większe przedmioty mogą kosztować więcej, a zamówienia międzynarodowe trwają dłużej niż krajowe.",
  "s5.p2":
    "Zawsze sprawdzaj informacje o wysyłce na głównej stronie przed złożeniem zamówienia. Jeśli oferta zawiera szacunkowy czas, traktuj go jako wskazówkę, a nie gwarancję.",

  "table.caption": "Szybkie porównanie: co sprawdzić przy każdym produkcie",
  "table.head1": "Czynnik",
  "table.head2": "Co sprawdzić",
  "table.head3": "Dlaczego to ważne",
  "table.r1c1": "Produkt",
  "table.r1c2": "Zdjęcia i opis",
  "table.r1c3": "Pomaga w researchu",
  "table.r2c1": "QC",
  "table.r2c2": "Informacje o kontroli jakości",
  "table.r2c3": "Pokazuje jakość",
  "table.r3c1": "Wysyłka",
  "table.r3c2": "Aktualne metody wysyłki",
  "table.r3c3": "Pomaga zaplanować dostawę",
  "table.r4c1": "Płatność",
  "table.r4c2": "Dostępne warunki płatności",
  "table.r4c3": "Zapewnia bezpieczeństwo zamówienia",

  "faq.title": "Często zadawane pytania",
  "faq.q1": "Czy USFans Spreadsheet jest darmowy do przeglądania?",
  "faq.a1":
    "Tak, przeglądanie kategorii i informacji o produktach w tym zasobie jest darmowe. Płacisz tylko wtedy, gdy zdecydujesz się kupić coś na głównej stronie.",
  "faq.q2": "Czy mogę kupować bezpośrednio na tej stronie?",
  "faq.a2":
    "Nie. Ta strona jest zasobem informacyjnym, który przekierowuje Cię do głównej strony USFans, gdzie realizowane są zakupy.",
  "faq.q3": "Jak często spreadsheet jest aktualizowany?",
  "faq.a3":
    "Spreadsheet jest regularnie utrzymywany i aktualizowany. Aby zobaczyć najnowsze oferty, zawsze sprawdzaj główną stronę.",
  "faq.q4": "Jak znaleźć konkretną kategorię?",
  "faq.a4":
    "Użyj rozwijanego menu lub kart kategorii na stronie głównej, aby od razu przejść do potrzebnej sekcji.",

  "cta.title": "Zacznij przeglądać USFans Spreadsheet",
  "cta.text":
    "Teraz, gdy rozumiesz, jak działa, przeglądaj kategorie i porównuj przed zakupem.",
  "cta.back": "Wróć do strony głównej",

  "safety.title": "Uwaga dotycząca bezpieczeństwa",
  "safety.text":
    "Ten przewodnik udostępnia tylko informacje. Zawsze weryfikuj szczegóły produktu i warunki wysyłki na głównej stronie przed dokonaniem zakupu.",
};